/**
 * Role ranking — the ONE place that says which role outranks which.
 *
 * Kept free of Firebase imports so pure modules (the dashboard widget framework in
 * `src/platform/widgets/`, `viewAs.js`, unit tests run with `node --test`) can use it.
 * `roleService` and `UserContext` re-use it; do not copy the numbers anywhere else.
 *
 * Keys are the stored role ids from `ROLE_DEFINITIONS` (src/services/roleService.js).
 * `executive` and `org_it` arrived with Beta-1 P4-03/04 (View As / downward visibility):
 * Org IT sees everyone (support role, no scope); an executive sees site managers and below.
 */
export const ROLE_HIERARCHY = Object.freeze({
  org_admin: 7,
  org_it: 6,
  executive: 5,
  site_manager: 4,
  department_lead: 3,
  team_lead: 2,
  respondent: 1,
});

/** Numeric rank of a stored role key; unknown / missing roles rank 0. */
export function roleRank(role) {
  return ROLE_HIERARCHY[role] || 0;
}

/**
 * Does `userRole` meet `requiredRole`?
 * Hierarchy: org_admin > org_it > executive > site_manager > department_lead > team_lead > respondent.
 * An unknown required role ranks 0, so everyone meets it (same as before the extraction).
 */
export function hasMinimumRole(userRole, requiredRole) {
  return roleRank(userRole) >= roleRank(requiredRole);
}
